// This is a stub for developers who do not have a module loader or are
// prototyping one-off scripts in a browser.
window.fbjs = require("./index.ts");
